import { createActions } from 'redux-actions';

const {
  addUserProfile,
  addUserProfileSuccess,
  addUserProfileFailure,
  resetAddProfileStatus,
} = createActions(
  'ADD_USER_PROFILE',
  'ADD_USER_PROFILE_SUCCESS',
  'ADD_USER_PROFILE_FAILURE',
  'RESET_ADD_PROFILE_STATUS'
);

export {
  addUserProfile,
  addUserProfileSuccess,
  addUserProfileFailure,
  resetAddProfileStatus,
};
